module.exports = __webpack_public_path__ + "static/media/landing_page_video_480p.b900edaa.mp4";